import React, { useState, useEffect } from "react";
import axios from "../common/axios";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "../components/ui/card";
import ShadcnPageWrapper from "./ShadcnPageWrapper";

export default function NewPW() {
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [strength, setStrength] = useState(0);
  const [message, setMessage] = useState("");
  const [isValid, setIsValid] = useState(true);
  // const history = useHistory();
  const navigate = useNavigate(); // useNavigate 사용

  const search = useLocation().search;
  const token = new URLSearchParams(search).get("token");
  const username = new URLSearchParams(search).get("username");

  useEffect(() => {
    if (!token || !username) {
      navigate("/dplogin", { replace: true });
    }
  }, [token, username, navigate]);

  useEffect(() => {
    if (password === "") {
      setIsValid(true);
    } else if (strength !== 5) {
      setIsValid(true);
    } else if (confirmpassword === "") {
      setIsValid(true);
    } else if (password !== confirmpassword) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [confirmpassword, password, strength]);

  // useEffect(() => {
  // 	setIsValid(strength ===5?false:true)
  //   },[strength])

  function isValidPassword(password) {
    const upperCaseRegex = /[A-Z]/;
    const lowerCaseRegex = /[a-z]/;
    const numberRegex = /\d/;
    const specialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

    const checks = [
      upperCaseRegex.test(password),
      lowerCaseRegex.test(password),
      numberRegex.test(password),
      specialCharRegex.test(password),
    ];

    const trueCounts = checks.filter(Boolean).length;

    if (trueCounts >= 3 && password.length >= 8) return true;
    if (trueCounts >= 2 && password.length >= 10) return true;

    return false;
  }

  // 제약 조건을 검사하는 Helper 함수들
  const hasSequentialCharacters = (str) =>
    /(012|123|234|345|456|567|678|789|890|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|qwe|wer|ert|rty|tyu|yui|uio|iop|asd|sdf|dfg|fgh|ghj|hjk|jkl|zxc|xcv|cvb|vbn|bnm)/i.test(
      str
    );

  const hasRepeatedCharacters = (str) => /(.)\1\1/.test(str);

  const isOnlyNumericOrAlpha = (str) => /^[0-9]+$|^[a-zA-Z]+$/.test(str);

  const validatePassword = (passwordValue) => {
    if (passwordValue.includes(username))
      return "패스워드가 사용자 계정과 동일합니다."; // 1번 제약 조건
    if (hasRepeatedCharacters(passwordValue))
      return "동일한 문자 또는 숫자가 3자 이상 사용되었습니다."; // 2번 제약 조건
    if (hasSequentialCharacters(passwordValue))
      return "주기성 문자나 키보드상의 연속된 배열이 3개 이상 사용되었습니다."; // 3번 제약 조건
    // 4번 제약 조건은 추가 정보(전화번호, 생년월일 등)가 필요하여 여기서 처리하지 않음
    if (isOnlyNumericOrAlpha(passwordValue))
      return "문자 또는 숫자만으로 구성된 패스워드는 허용되지 않습니다."; // 6번 제약 조건
    if (passwordValue === "") return "Null 패스워드는 허용되지 않습니다."; // 7번 제약 조건

    if (!isValidPassword(passwordValue)) {
      return "패스워드는 다음의 문자 종류 중 2종류 이상을 조합하여 최소 10자리 이상 또는 3종류 이상을 조합하여 최소 8자리 이상의 길이로 작성하여야 합니다. * 영문 대문자(26개), 영문 소문자(26개), 숫자(10개), 특수문자(32개)";
    }
    return null; // 유효한 패스워드
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    const validationResult = validatePassword(newPassword);

    if (validationResult === null) {
      setMessage("사용가능한 비밀번호입니다.");
    } else {
      setMessage(validationResult);
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const newPassword = e.target.value;
    setConfirmPassword(newPassword);

    if (password === newPassword) {
      setMessage("비밀번호가 서로 일치합니다.");
    } else {
      setMessage("비밀번호가 서로 일치하지 않습니다.");
    }
  };

  function getPasswordStrength(password) {
    let score = 0;
    const consecutivePattern = /(.)\1\1+/; // 3번 이상 연속되는 문자

    if (password.length >= 10) score++;
    if (/[^a-zA-Z0-9]/.test(password)) score++;
    if (/[0-9]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/[A-Z]/.test(password)) score++;
    if (consecutivePattern.test(password)) score = 0; // 연속된 문자가 있다면 점수를 0으로 초기화

    return score;
  }

  useEffect(() => {
    setStrength(getPasswordStrength(password));
  }, [password]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`/dpnew-password`, { token, password });
      // 성공 응답 처리
      if (response.data.success) {
        setMessage(response.data.message); // 성공 메시지 설정
        navigate("/dppassword-confirmation");
      } else {
        // 예상치 못한 응답 처리
        setMessage(
          "비밀번호 재설정에 문제가 발생했습니다. 시스템 관리자에게 연락하시기 바랍니다."
        );
      }
    } catch (err) {
      console.log(err);
      if (err.response && err.response.data && err.response.data.error) {
        // 서버에서 반환하는 에러 메시지를 사용자에게 보여줍니다.
        setMessage(err.response.data.error);
      } else {
        setMessage(
          "비밀번호 재설정에 문제가 발생했습니다. 시스템 관리자에게 연락하시기 바랍니다."
        );
      }
    }
  };

  return (
    <ShadcnPageWrapper>
      <div className="flex min-h-screen">
        {/* 좌측: 새 비밀번호 설정 폼 */}
        <div className="flex flex-1 flex-col items-center justify-center px-4 py-12">
          <div className="w-full sm:w-[380px]">
            <div className="mb-8 flex flex-col items-center gap-2">
              <img src="/images/g1313.png" alt="삼성중공업" className="h-10 w-auto" />
              <h1 className="m-0 text-xl font-bold text-foreground">
                삼성중공업 하이테크 통합 DP 시스템
              </h1>
              <p className="m-0 text-sm text-muted-foreground">
                이미 비밀번호를 새로 설정하셨나요?{" "}
                <span
                  className="cursor-pointer font-medium text-[hsl(222,80%,40%)] hover:underline"
                  onClick={() => navigate("/dplogin")}
                >
                  로그인
                </span>
              </p>
            </div>

            <Card>
              <CardHeader>
                <CardTitle className="text-base no-underline">새 비밀번호 설정</CardTitle>
                <CardDescription>새 비밀번호를 입력하세요.</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="space-y-1.5">
                    <Label htmlFor="password">비밀번호</Label>
                    <Input
                      id="password"
                      type="password"
                      placeholder="비밀번호"
                      name="password"
                      autoComplete="off"
                      onChange={handlePasswordChange}
                    />
                    <div className="flex items-center gap-2 pt-1">
                      <div
                        className={`h-1 flex-1 rounded-full ${
                          strength > 0 ? "bg-green-500" : "bg-gray-200"
                        }`}
                      ></div>
                      <div
                        className={`h-1 flex-1 rounded-full ${
                          strength > 1 ? "bg-green-500" : "bg-gray-200"
                        }`}
                      ></div>
                      <div
                        className={`h-1 flex-1 rounded-full ${
                          strength > 2 ? "bg-green-500" : "bg-gray-200"
                        }`}
                      ></div>
                      <div
                        className={`h-1 flex-1 rounded-full ${
                          strength > 3 ? "bg-green-500" : "bg-gray-200"
                        }`}
                      ></div>
                      <div
                        className={`h-1 flex-1 rounded-full ${
                          strength > 4 ? "bg-green-500" : "bg-gray-200"
                        }`}
                      ></div>
                    </div>
                    <p className="text-xs text-muted-foreground">
                      최소 10글자 이상의 비밀번호를 사용해주세요. 비밀번호에는 대문자, 소문자,
                      특수문자 등이 포함되어야하며, 3개 이상의 연속된 문자를 사용할 수 없습니다.
                    </p>
                  </div>

                  <div className="space-y-1.5">
                    <Label htmlFor="confirm-password">비밀번호 재입력</Label>
                    <Input
                      id="confirm-password"
                      type="password"
                      placeholder="비밀번호 재입력"
                      name="confirm-password"
                      autoComplete="off"
                      onChange={handleConfirmPasswordChange}
                    />
                  </div>

                  {message && <p className="text-xs text-muted-foreground">{message}</p>}

                  <Button
                    type="button"
                    disabled={isValid}
                    onClick={handleSubmit}
                    className="w-full border-0 bg-[hsl(222,80%,40%)] text-[#fff] hover:bg-[hsl(222,80%,40%)]/80"
                  >
                    제출
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* 우측: 브랜드 패널 (lg 이상에서만 표시) */}
        <div className="hidden flex-1 flex-col items-center justify-center bg-[#0F2744] px-12 lg:flex">
          <div className="max-w-md text-center text-[#fff]">
            <h2 className="m-0 text-3xl font-bold leading-tight">
              삼성중공업 하이테크 부문 DP 시스템
            </h2>
            <p className="m-0 mt-4 text-base text-[#fff]/70">
              Oracle Unifier와 연동되어 승인도·제작도의 계획/실적 데이터를 실시간으로 관리합니다.
            </p>
          </div>
        </div>
      </div>
    </ShadcnPageWrapper>
  );
}
